import { defineComponent as _defineComponent } from 'vue'
import AccountSelectModal from "@/components/modules/account/AccountSelectModal.vue";
import AccountSelectSearch from "@/components/modules/account/AccountSelectSearch.vue";

import UserBreadcrumb from "@/components/common/UserBreadcrumb.vue";
import { computed, ref } from "vue";
import { useRoute } from "vue-router/composables";
import CompanyFullReport from "./components/CompanyFullReport.vue";
import IndividualFullReport from "./components/IndividualFullReport.vue";
import { useTranslation } from "@/store/translation";


export default /*#__PURE__*/_defineComponent({
  __name: 'FullReport',
  setup(__props) {

const showAccountSelectionModal = ref(false);
const { $t } = useTranslation();

const route = useRoute();

const showCompany = computed(() => {
  return route.query.userId === "admin";
});

return { __sfc: true,showAccountSelectionModal, $t, route, showCompany, AccountSelectModal, AccountSelectSearch, UserBreadcrumb, CompanyFullReport, IndividualFullReport }
}

})